import AuthMixin from '@/components/mixins/auth-mixin'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'

export default {
  name: 'leftAccountPage',
  inject: [
    '$utils'
  ],
  mixins: [AuthMixin],
  data () {
    return {
      accountName: null
    }
  },
  methods: {
    setDefaultData () {
      this.accountName = this.$route.params?.accountName ?? ''
    },
    handleContinueClick () {
      if (this.$utils.isPageForLicenses()) {
        this.$router.push('/')
      } else {
        this.$router.push('/menu')
      }
    }
  },
  mounted () {
    useMixpanel().track('Left Account')

    this.isAuthenticated({
      callback: () => {
        this.setDefaultData()
      }
    })
  }
}
